module.exports = __webpack_public_path__ + "static/media/컬러링 썸네일.bce2ca08.png";